module.exports = __webpack_public_path__ + "static/img/13.1d255b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/13.png
// module id = vAj1
// module chunks = 0